import { useState, useMemo } from 'react'
import { InsightContentSettingType } from 'components/insightContent/types'
import CountType from 'enums/CountType'
import {
  convertToInsightContentSetting,
  addSelectionFilterToWidgetSetting
} from '../share/InsightModal/utils'
import {
  WordCloudWidgetsType,
  WordCloudSelectionType,
  TableSelectionType,
  InsightObjective
} from '../types'
import useSearchFilterComposingStrategy from './useSearchFilterComposingStrategy'
import useWidgetSettingComposingStrategy from './useWidgetSettingComposingStrategy'

const useSelectedInsights = (widgetSetting: WordCloudWidgetsType) => {
  const countType = widgetSetting.countType || CountType.MENTIONS
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selection, setSelection] = useState<InsightObjective[]>([])
  const searchFilterComposingStrategy = useSearchFilterComposingStrategy(widgetSetting.viewOption!)
  const widgetSettingComposingStrategy = useWidgetSettingComposingStrategy(
    widgetSetting.viewOption!
  )

  const detailSetting = useMemo<InsightContentSettingType | undefined>(() => {
    if (isModalOpen && selection.length > 0) {
      return convertToInsightContentSetting(widgetSetting, searchFilterComposingStrategy, selection)
    }
    return undefined
  }, [isModalOpen, widgetSetting, searchFilterComposingStrategy, selection])

  const widgetSettingWithSelection = useMemo<any>(() => {
    if (isModalOpen && selection.length > 0) {
      return addSelectionFilterToWidgetSetting(
        widgetSetting,
        widgetSettingComposingStrategy,
        selection
      )
    }
    return undefined
  }, [isModalOpen, widgetSetting, widgetSettingComposingStrategy, selection])

  const handleWordCloudClick = (target: WordCloudSelectionType) => {
    setSelection([
      {
        insight: target.custom,
        name: target.text
      }
    ])
    setIsModalOpen(true)
  }

  const handleTableClick = (target: TableSelectionType) => {
    setSelection([{ insight: target.insight, name: target.name }])
    setIsModalOpen(true)
  }

  return {
    isModalOpen,
    setIsModalOpen,
    selection,
    countType,
    detailSetting,
    handleWordCloudClick,
    handleTableClick,
    widgetSettingWithSelection
  }
}

export default useSelectedInsights
